import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { usePrefersReducedMotion } from '@hooks';
import createDataRain from '@utils/datarain';

const StyledBackgroundFx = styled.canvas`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  opacity: 0;
  transition: opacity 1.2s var(--easing);

  &[data-active='true'] {
    opacity: 1;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

const BackgroundFx = ({ active = true }) => {
  const canvasRef = useRef(null);
  const sceneRef = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    const rain = createDataRain(canvasRef.current);
    sceneRef.current = rain;

    return () => {
      rain.destroy();
      sceneRef.current = null;
    };
  }, []);

  useEffect(() => {
    const rain = sceneRef.current;
    if (!rain || !active) return undefined;

    if (prefersReducedMotion) {
      rain.renderOnce();
      return undefined;
    }

    rain.start();
    return () => rain.stop();
  }, [active, prefersReducedMotion]);

  return (
    <StyledBackgroundFx
      ref={canvasRef}
      aria-hidden="true"
      data-active={active ? 'true' : 'false'}
    />
  );
};

BackgroundFx.propTypes = {
  // Keeps the render loop parked while a full-screen loader is still up.
  active: PropTypes.bool,
};

export default BackgroundFx;
